export const packagesInitialState = {
    packages: null,
    isLoading: true,
}